import Api from "@/lib/Api"
import { AdminUser, Teamspace } from "@/models/core"

export const getMyAdminUser = (): Promise<AdminUser> => Api.get<AdminUser>("/admn/admin_users/me/")

export const setAdminUserTeamspace = (adminUserId: number, teamspace: Teamspace): Promise<AdminUser> =>  Api.post(`/admn/admin_user/${adminUserId}/set_current_teamspace/`, teamspace)
